<template>
  <div>
    <div class="upload-block mb-4">
      <label for="banner-img-edit-desktop" class="upload-label"
        >Изображение (десктоп)</label
      >
      <input
        id="banner-img-edit-desktop"
        class="upload-img-input"
        accept="image/x-png,image/jpg,image/jpeg,image/png,image/webp"
        type="file"
        @change="onFilePickedDesktop"
      />
    </div>
    <div v-if="imageDataDesktop !== '' || currentBanner.url" class="mb-4">
      <p class="mb-2 text-muted small">Десктоп:</p>
      <img
        :src="imageDataDesktop || currentBanner.url"
        alt=""
        class="banner-preview"
      />
    </div>
    <div class="upload-block mb-4">
      <label for="banner-img-edit-mobile" class="upload-label"
        >Изображение (мобильная версия)</label
      >
      <input
        id="banner-img-edit-mobile"
        class="upload-img-input"
        accept="image/x-png,image/jpg,image/jpeg,image/png,image/webp"
        type="file"
        @change="onFilePickedMobile"
      />
    </div>
    <div v-if="imageDataMobile !== '' || currentBanner.url_mobile" class="mb-4">
      <p class="mb-2 text-muted small">Мобильная версия:</p>
      <img
        :src="
          imageDataMobile ||
          currentBanner.url_mobile ||
          currentBanner.featured_url_mobile
        "
        alt=""
        class="banner-preview"
      />
    </div>
    <div class="mb-4">
      <label>Ссылка</label>
      <va-input v-model="promoBannerLink" />
      <div
        v-if="
          !$v.promoBannerLink.checkWebsiteValid && $v.promoBannerLink.$dirty
        "
      >
        <p>Проверьте адрес сайта</p>
      </div>
    </div>
    <div class="mb-4">
      <label>Статус</label>
      <va-checkbox v-model="promoBannerActive" />
      <span>{{ promoBannerActive ? "Включен" : "Выключен" }}</span>
    </div>
    <div class="mt-4 text-center">
      <va-button color="primary" type="button" @click="$emit('hide', true)">
        Отменить
      </va-button>

      <va-button 
        color="success" 
        type="submit" 
        :disabled="isSubmitting"
        @click="handleSubmitClick"
      >
        {{ isSubmitting ? 'Сохранение...' : 'Сохранить' }}
      </va-button>
    </div>
  </div>
</template>

<script>
import api from "@/api/axios";
import { mapActions } from "vuex";
import { helpers } from "vuelidate/lib/validators";

// Валидация для URL: принимает полные URL (http/https) и относительные пути (начинающиеся с /)
const validateUrl = (value) => {
  if (!value || value.trim() === "") {
    return true; // Пустое значение допустимо
  }
  const trimmed = value.trim();
  // Проверяем относительный путь (начинается с /)
  if (trimmed.startsWith('/')) {
    return true;
  }
  // Проверяем полный URL
  const urlPattern = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i;
  return urlPattern.test(trimmed);
};

export default {
  props: {
    banner: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fileDesktop: null,
      fileMobile: null,
      imageDataDesktop: "",
      imageDataMobile: "",
      promoBannerLink: "",
      promoBannerGroup: "main",
      promoBannerActive: true,
      currentBanner: {},
      isSubmitting: false,
    };
  },
  validations: {
    promoBannerLink: {
      checkWebsiteValid: helpers.withParams({}, validateUrl),
    },
  },
  created() {
    this.currentBanner = { ...this.banner };
    this.promoBannerLink = this.banner.target_url || "";
    // Всегда используем группу 'main'
    this.promoBannerGroup = "main";
    this.promoBannerActive = Boolean(this.banner.active);
  },
  beforeDestroy() {
    // Освобождаем URL объекты для предотвращения утечек памяти
    if (this.imageDataDesktop && this.imageDataDesktop.startsWith('blob:')) {
      URL.revokeObjectURL(this.imageDataDesktop);
    }
    if (this.imageDataMobile && this.imageDataMobile.startsWith('blob:')) {
      URL.revokeObjectURL(this.imageDataMobile);
    }
  },
  methods: {
    ...mapActions({
      fetchPromoBanners: "promoBanners/getPromoBanners",
    }),
    handleSubmitClick(event) {
      if (this.isSubmitting) {
        return;
      }
      this.submit();
    },
    onFilePickedDesktop(event) {
      const file = event.target.files && event.target.files[0];
      if (file) {
        // Проверка типа файла
        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
        if (!validTypes.includes(file.type)) {
          alert('Пожалуйста, выберите изображение в формате PNG, JPG или WebP');
          event.target.value = ''; // Очищаем input
          return;
        }
        // Проверка размера файла (например, максимум 10MB)
        const maxSize = 10 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
          alert('Размер файла не должен превышать 10MB');
          event.target.value = ''; // Очищаем input
          return;
        }
        this.fileDesktop = file;
        // Освобождаем предыдущий URL, если он был создан
        if (this.imageDataDesktop && this.imageDataDesktop.startsWith('blob:')) {
          URL.revokeObjectURL(this.imageDataDesktop);
        }
        this.imageDataDesktop = URL.createObjectURL(this.fileDesktop);
      }
    },
    onFilePickedMobile(event) {
      const file = event.target.files && event.target.files[0];
      if (file) {
        // Проверка типа файла
        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
        if (!validTypes.includes(file.type)) {
          alert('Пожалуйста, выберите изображение в формате PNG, JPG или WebP');
          event.target.value = ''; // Очищаем input
          return;
        }
        // Проверка размера файла (например, максимум 10MB)
        const maxSize = 10 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
          alert('Размер файла не должен превышать 10MB');
          event.target.value = ''; // Очищаем input
          return;
        }
        this.fileMobile = file;
        // Освобождаем предыдущий URL, если он был создан
        if (this.imageDataMobile && this.imageDataMobile.startsWith('blob:')) {
          URL.revokeObjectURL(this.imageDataMobile);
        }
        this.imageDataMobile = URL.createObjectURL(this.fileMobile);
      }
    },
    async submit() {
      if (this.isSubmitting) {
        return;
      }
      
      this.isSubmitting = true;

      // Валидация ссылки (если она заполнена)
      if (this.promoBannerLink && this.promoBannerLink.trim() !== '') {
        const linkValidationPassed = validateUrl(this.promoBannerLink);
        if (!linkValidationPassed) {
          // Не блокируем отправку, только предупреждаем
        }
      }
      
      // Проверяем vuelidate валидацию
      this.$v.$touch();
      
      // Игнорируем ошибки валидации vuelidate для необязательного поля ссылки
      // и продолжаем отправку, если есть хотя бы файл для загрузки
      if (this.$v.$invalid && !this.fileDesktop && !this.fileMobile) {
        alert('Пожалуйста, выберите хотя бы одно изображение или проверьте правильность ссылки');
        this.isSubmitting = false;
        return false;
      }
      
      try {
        const data = {
          active: this.promoBannerActive,
          group: this.promoBannerGroup,
        };
        if (this.fileDesktop) {
          const formData = new FormData();
          formData.append("file", this.fileDesktop, this.fileDesktop.name);
          formData.append("skip_optimize", "1");
          try {
            const fileInfo = await api.post("/upload-file", formData);
            if (fileInfo && fileInfo.data && fileInfo.data.id) {
              data.photo_id = fileInfo.data.id;
            } else {
              alert("Ошибка загрузки изображения для десктопа");
              this.isSubmitting = false;
              return false;
            }
          } catch (uploadError) {
            console.error("Error uploading desktop image:", uploadError);
            const errorMessage = uploadError.response?.data?.message || uploadError.message || "Ошибка загрузки изображения для десктопа";
            alert(errorMessage);
            this.isSubmitting = false;
            return false;
          }
        }

        if (this.fileMobile) {
          const formDataMobile = new FormData();
          formDataMobile.append("file", this.fileMobile, this.fileMobile.name);
          formDataMobile.append("skip_optimize", "1");
          try {
            const fileMobileInfo = await api.post("/upload-file", formDataMobile);
            if (fileMobileInfo && fileMobileInfo.data && fileMobileInfo.data.id) {
              data.photo_mobile_id = fileMobileInfo.data.id;
            } else {
              alert("Ошибка загрузки изображения для мобильной версии");
              this.isSubmitting = false;
              return false;
            }
          } catch (uploadError) {
            console.error("Error uploading mobile image:", uploadError);
            const errorMessage = uploadError.response?.data?.message || 
                                uploadError.response?.data?.error || 
                                uploadError.message || 
                                "Ошибка загрузки изображения для мобильной версии";
            alert(`Ошибка загрузки: ${errorMessage}`);
            this.isSubmitting = false;
            return false;
          }
        }

        if (this.promoBannerLink) {
          data.target_url = this.promoBannerLink;
        } else {
          data.target_url = null;
        }

        await api.put(`/admin/promo-banners/${this.banner.id}`, data);
        await this.fetchPromoBanners();
        
        // Очищаем выбранные файлы после успешной загрузки
        this.fileDesktop = null;
        this.fileMobile = null;
        // Очищаем input элементы
        const desktopInput = document.getElementById('banner-img-edit-desktop');
        const mobileInput = document.getElementById('banner-img-edit-mobile');
        if (desktopInput) desktopInput.value = '';
        if (mobileInput) mobileInput.value = '';
        
        this.isSubmitting = false;
        this.$emit("hide", true);
      } catch (error) {
        console.error("Error updating banner:", error);
        let errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Произошла ошибка при обновлении баннера";
        if (!error.response) {
          errorMessage =
            "Ошибка сети. Если загружаете новое фото, проверьте размер файла (до 30 МБ).";
        }
        alert(`Ошибка обновления: ${errorMessage}`);
        this.isSubmitting = false;
        return error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-preview {
  display: block;
  max-width: 100%;
  width: 100%;
  max-width: 500px;
  max-height: 200px;
  object-fit: contain;
  margin: 0 auto;
}
.text-muted {
  color: #6c757d;
}
.small {
  font-size: 0.875rem;
}
.upload-block {
  position: relative;
}
.upload-img-input {
  appearance: none;
  visibility: hidden;
}
.upload-label {
  padding: 0.375rem 1.25rem;
  background-color: rgb(44, 130, 224);
  color: #fff;
  font-weight: bold;
  border-radius: 1.5rem;
  cursor: pointer;
  display: inline-block;
}
</style>
